import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/edit.svg';

export const IconEdit: IconComponent = props => <Icon {...props} src={src} />;
